<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">校区管理</span>

    <div class="box">
      <el-button size="mini" type="primary" @click="addCampus">
        创建校区
      </el-button>
      <el-table :data="tableData" class="table" border stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="CreatedAt" label="日期"></el-table-column>
        <el-table-column prop="Name" label="名称"></el-table-column>
        <el-table-column prop="principal" label="校长">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              class="elTagClass"
              v-for="(item, k) in scope.row.principal"
              :key="k"
            >
              {{ item.User.Nickname }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="130">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="add_visible_button(scope.row)"
            >
              添加校长
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_principal_button(scope.row)"
            >
              删除校长
            </el-button>
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="editCampus(scope.row)"
            >
              修改
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 创建/修改弹框 -->
    <el-dialog
      :title="form.School ? '修改校区' : '创建校区'"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-form
        ref="form_ref"
        :model="form"
        :rules="rules"
        label-width="80px"
        label-position="right"
      >
        <el-form-item label="校区名称" prop="Name">
          <el-input v-model="form.Name" placeholder="请输入校区名称">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="addDialog" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 添加校长弹框 -->
    <el-dialog
      title="添加校长"
      :visible.sync="add_visible_principal"
      width="40%"
    >
      <p><span>校区：</span>{{ add_form_principal.Name }}</p>
      <el-select
        filterable
        class="elselect"
        v-model="add_form_principal.headmaster"
        placeholder="请选择用户作为校长"
      >
        <el-option
          v-for="item in options"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="add_visible_principal = false" size="mini"
          >取消</el-button
        >
        <el-button type="primary" @click="add_principal_frame" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 删除校长弹框 -->
    <el-dialog title="删除校长" :visible.sync="delete_principal" width="40%">
      <span>校长：</span>
      <el-select
        class="elselect"
        v-model="delete_select"
        placeholder="请选择校长"
      >
        <el-option
          v-for="item in delete_form.principal"
          :key="item.Id"
          :label="item.User.Nickname"
          :value="item.Id"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="delete_principal = false" size="mini"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="delete_principal_determine"
          size="mini"
        >
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import loading from "@/components/loading.vue";
import { mapGetters } from "vuex";
import {
  postSchool,
  getSchool,
  putSchool,
  getAllUser,
  get_school_role,
  post_user_school,
  delete_principal,
} from "@/api/admin.js";

export default {
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {
    loading,
  },
  data() {
    return {
      rules: {
        // 验证用户名是否合法
        Name: [{ required: true, message: "请输入校区名称", trigger: "blur" }],
      },
      dialogVisible: false,
      add_visible_principal: false, //添加校长弹框
      delete_principal: false, //删除校长弹框
      form: { Name: "", headmaster: "" },
      add_form_principal: { Name: "", headmaster: "" }, //添加校长表单
      tableData: [],
      options: [],
      delete_form: [],
      delete_select: "",
      loading_ok: "",
    };
  },

  created() {
    this.getSchoolFuntion();
    this.getAllUserFuntion();
  },

  methods: {
    // 获取校区
    getSchoolFuntion() {
      getSchool().then((res) => {
        res.data.forEach((v) => {
          v.CreatedAt = this.filters.vdateAdd(v.CreatedAt);
          get_school_role(v.Id, "校长").then((item) => {
            v.principal = item.data;
            setTimeout(() => {
              this.loading_ok = false;
              this.dialogVisible = false;
              this.tableData = res.data;
            }, 500);
          });
        });
      });
    },

    //获取所有用户
    getAllUserFuntion() {
      getAllUser().then((res) => {
        this.options = res.data;
      });
    },

    addCampus() {
      if (this.$refs.form_ref !== undefined) {
        this.$refs.form_ref.clearValidate();
      }

      this.form = {};
      this.dialogVisible = true;
    },

    //确定按钮
    addDialog() {
      this.$refs.form_ref.validate((valid) => {
        if (valid) {
          let data = { name: this.form.Name };
          if (this.form.School) {
            if (this.form.School == this.form.Name) {
              this.$message.error("禁止修改相同名称！");
              return false;
            }
            putSchool(this.form.School, data).then(() => {
              this.getSchoolFuntion();
              this.$message.success("修改成功！");
            });
          } else {
            postSchool(this.form).then(() => {
              this.getSchoolFuntion();
              this.$message.success("创建成功！");
            });
          }
        }
      });
    },

    editCampus(item) {
      this.form = {
        headmaster: item.Headmasters,
        Name: item.Name,
        School: item.Name,
      };
      this.dialogVisible = true;
    },

    // 添加校长按钮
    add_visible_button(v) {
      this.add_form_principal.headmaster = "";
      this.add_form_principal = v;
      this.add_visible_principal = true;
    },

    // 添加校长弹框确定按钮
    add_principal_frame() {
      if (!this.add_form_principal.headmaster) {
        this.$message.error("用户不能为空！");
        return false;
      }

      let data = {
        roleName: "校长",
        schoolId: this.add_form_principal.Id,
        userId: this.add_form_principal.headmaster,
      };

      post_user_school(data).then(() => {
        this.getSchoolFuntion();
        this.$message.success("添加成功！");
        this.add_visible_principal = false;
      });
    },

    // 删除校长按钮
    delete_principal_button(item) {
      this.delete_select = "";
      this.delete_form = item;
      this.delete_principal = true;
    },

    // 删除校长弹框确定
    delete_principal_determine() {
      if (!this.delete_select) {
        this.$message.error("请选择校长！");
        return false;
      }

      delete_principal(this.delete_select).then(() => {
        this.getSchoolFuntion();
        this.delete_principal = false;
        this.$message.success("删除成功！");
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    .box {
        margin-top:30px;
    }
   .table {
     margin-top:20px;
   }
   .elselect {
     margin-top:12px;
   }
   .elTagClass {
    margin-right:6px;
  }
}
</style>
